import { lazyGetStoreState as lazyGetTruTimeStoreState, State } from 'owa-truetime';
import getSelectedAccountProvider from '../selectors/getSelectedAccountProvider';
import getTrueTimeUpdateFailedAccount from '../selectors/getTrueTimeUpdateFailedAccount';
import getAccountsEditorState from '../selectors/getAccountsEditorState';
import {
    accountStatusError,
    trueTimeError,
    trueTimeUpdateErrorOnExistingAccount,
    trueTimeUpdateErrorDuringAdd,
    trueTimeUpdateErrorDuringRemove,
    accountRemoveError,
    accountReconnectError,
} from '../components/ConnectedAccount.locstring.json';
import loc from 'owa-localize';
import { OWAConnectedAccount, OWAConnectedAccountState } from 'owa-accounts-store';
import { AccountsEditorState } from '../store/schema/AccountsEditorState';

export default function getErrorMessage(account: OWAConnectedAccount): string {
    const getTruTimeStoreState = lazyGetTruTimeStoreState.tryImportForRender();
    const truTimeState = getTruTimeStoreState ? getTruTimeStoreState() : undefined;
    const accountsEditorState = getAccountsEditorState();

    switch (accountsEditorState) {
        case AccountsEditorState.None:
        case AccountsEditorState.Added:
            if (account.accountState != OWAConnectedAccountState.Valid) {
                return loc(accountStatusError);
            }
            if (truTimeState === State.Error) {
                return loc(trueTimeError);
            }
            if (getTrueTimeUpdateFailedAccount() == account.userIdentity) {
                return loc(trueTimeUpdateErrorOnExistingAccount);
            }
            break;
        case AccountsEditorState.AddFailed:
            if (getSelectedAccountProvider() == account.accountProviderType) {
                if (getTrueTimeUpdateFailedAccount() == account.userIdentity) {
                    return loc(trueTimeUpdateErrorDuringAdd);
                }
            }
            break;
        case AccountsEditorState.RemoveFailed:
            if (getSelectedAccountProvider() == account.accountProviderType) {
                if (getTrueTimeUpdateFailedAccount() == account.userIdentity) {
                    return loc(trueTimeUpdateErrorDuringRemove);
                } else {
                    return loc(accountRemoveError);
                }
            }

            break;
        case AccountsEditorState.ReconnectFailed:
            if (getSelectedAccountProvider() == account.accountProviderType) {
                return loc(accountReconnectError);
            }
            break;
    }

    return null;
}
